import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IntegrationsService } from 'app/integrations/integration.service';
import { IntegrationPlatformType } from 'app/integrations/models/integration.model';
import { AmplitudeService } from 'app/shared/services/amplitude.service';
import { HttpParams } from '@angular/common/http';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'cc-confirm-integration',
  templateUrl: 'init-integration.component.html',
  styleUrls: ['init-integration.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class InitIntegrationComponent implements OnInit {
  public integratedPlatformType: IntegrationPlatformType;

  constructor(
    private route: ActivatedRoute,
    private integrationsService: IntegrationsService,
    private notificationService: NotificationService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.integratedPlatformType = this.route.snapshot.paramMap
      .get('integratedPlatformType')
      .toUpperCase() as IntegrationPlatformType;

    this.logAmplitudeEvent('Panel:Integrations:Init: Init');

    const httpParams = new HttpParams({
      fromObject: this.route.snapshot.queryParams
    });

    this.integrationsService.initIntegration(this.integratedPlatformType, httpParams).subscribe(
      response => {
        if (response.redirectUri) {
          this.logAmplitudeEvent('Panel:Integrations:Init: Redirect');
          window.location.href = response.redirectUri;
        }
      },
      error => {
        this.notificationService.open('ERROR');
      }
    );
  }

  private logAmplitudeEvent(event: string) {
    this.amplitudeService.logEvent(event, {
      platform: this.integratedPlatformType
    });
  }
}
